/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CoaAccountDTO,
  CountTransaccsParams,
  GetAllTransaccsParams,
  GetCashBankTransferAccountsParams,
  TransaccDTO
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getAllTransaccs = (
    params: GetAllTransaccsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TransaccDTO[]>(
      {url: `/api/transaccs`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetAllTransaccsInfiniteQueryKey = (params?: GetAllTransaccsParams,) => {
    return [
    'infinite', `/api/transaccs`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetAllTransaccsQueryKey = (params?: GetAllTransaccsParams,) => {
    return [
    `/api/transaccs`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAllTransaccsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllTransaccs>>>, TError = unknown>(params: GetAllTransaccsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllTransaccs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllTransaccsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllTransaccs>>> = ({ signal }) => getAllTransaccs(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllTransaccs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllTransaccsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllTransaccs>>>
export type GetAllTransaccsInfiniteQueryError = unknown


export function useGetAllTransaccsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllTransaccs>>>, TError = unknown>(
 params: GetAllTransaccsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllTransaccs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllTransaccs>>,
          TError,
          Awaited<ReturnType<typeof getAllTransaccs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllTransaccsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllTransaccs>>>, TError = unknown>(
 params: GetAllTransaccsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllTransaccs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllTransaccs>>,
          TError,
          Awaited<ReturnType<typeof getAllTransaccs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllTransaccsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllTransaccs>>>, TError = unknown>(
 params: GetAllTransaccsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllTransaccs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllTransaccsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllTransaccs>>>, TError = unknown>(
 params: GetAllTransaccsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllTransaccs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllTransaccsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllTransaccsQueryOptions = <TData = Awaited<ReturnType<typeof getAllTransaccs>>, TError = unknown>(params: GetAllTransaccsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTransaccs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllTransaccsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllTransaccs>>> = ({ signal }) => getAllTransaccs(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllTransaccs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllTransaccsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllTransaccs>>>
export type GetAllTransaccsQueryError = unknown


export function useGetAllTransaccs<TData = Awaited<ReturnType<typeof getAllTransaccs>>, TError = unknown>(
 params: GetAllTransaccsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTransaccs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllTransaccs>>,
          TError,
          Awaited<ReturnType<typeof getAllTransaccs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllTransaccs<TData = Awaited<ReturnType<typeof getAllTransaccs>>, TError = unknown>(
 params: GetAllTransaccsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTransaccs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllTransaccs>>,
          TError,
          Awaited<ReturnType<typeof getAllTransaccs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllTransaccs<TData = Awaited<ReturnType<typeof getAllTransaccs>>, TError = unknown>(
 params: GetAllTransaccsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTransaccs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllTransaccs<TData = Awaited<ReturnType<typeof getAllTransaccs>>, TError = unknown>(
 params: GetAllTransaccsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTransaccs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllTransaccsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const updateTransacc = (
    transaccDTO: TransaccDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<TransaccDTO>(
      {url: `/api/transaccs`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: transaccDTO
    },
      options);
    }
  


export const getUpdateTransaccMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTransacc>>, TError,{data: TransaccDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTransacc>>, TError,{data: TransaccDTO}, TContext> => {

const mutationKey = ['updateTransacc'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTransacc>>, {data: TransaccDTO}> = (props) => {
          const {data} = props ?? {};

          return  updateTransacc(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateTransaccMutationResult = NonNullable<Awaited<ReturnType<typeof updateTransacc>>>
    export type UpdateTransaccMutationBody = TransaccDTO
    export type UpdateTransaccMutationError = unknown

    export const useUpdateTransacc = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTransacc>>, TError,{data: TransaccDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTransacc>>,
        TError,
        {data: TransaccDTO},
        TContext
      > => {

      const mutationOptions = getUpdateTransaccMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const createTransacc = (
    transaccDTO: TransaccDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TransaccDTO>(
      {url: `/api/transaccs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: transaccDTO, signal
    },
      options);
    }
  


export const getCreateTransaccMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTransacc>>, TError,{data: TransaccDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createTransacc>>, TError,{data: TransaccDTO}, TContext> => {

const mutationKey = ['createTransacc'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTransacc>>, {data: TransaccDTO}> = (props) => {
          const {data} = props ?? {};

          return  createTransacc(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateTransaccMutationResult = NonNullable<Awaited<ReturnType<typeof createTransacc>>>
    export type CreateTransaccMutationBody = TransaccDTO
    export type CreateTransaccMutationError = unknown

    export const useCreateTransacc = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTransacc>>, TError,{data: TransaccDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTransacc>>,
        TError,
        {data: TransaccDTO},
        TContext
      > => {

      const mutationOptions = getCreateTransaccMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getTransacc = (
    glNo: string,
    acNo: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TransaccDTO>(
      {url: `/api/transaccs/${glNo}/${acNo}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetTransaccInfiniteQueryKey = (glNo?: string,
    acNo?: string,) => {
    return [
    'infinite', `/api/transaccs/${glNo}/${acNo}`
    ] as const;
    }

export const getGetTransaccQueryKey = (glNo?: string,
    acNo?: string,) => {
    return [
    `/api/transaccs/${glNo}/${acNo}`
    ] as const;
    }

    
export const getGetTransaccInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getTransacc>>>, TError = unknown>(glNo: string,
    acNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTransacc>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTransaccInfiniteQueryKey(glNo,acNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTransacc>>> = ({ signal }) => getTransacc(glNo,acNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(glNo && acNo), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTransacc>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetTransaccInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getTransacc>>>
export type GetTransaccInfiniteQueryError = unknown


export function useGetTransaccInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getTransacc>>>, TError = unknown>(
 glNo: string,
    acNo: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTransacc>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransacc>>,
          TError,
          Awaited<ReturnType<typeof getTransacc>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTransaccInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getTransacc>>>, TError = unknown>(
 glNo: string,
    acNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTransacc>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransacc>>,
          TError,
          Awaited<ReturnType<typeof getTransacc>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTransaccInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getTransacc>>>, TError = unknown>(
 glNo: string,
    acNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTransacc>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetTransaccInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getTransacc>>>, TError = unknown>(
 glNo: string,
    acNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTransacc>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetTransaccInfiniteQueryOptions(glNo,acNo,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetTransaccQueryOptions = <TData = Awaited<ReturnType<typeof getTransacc>>, TError = unknown>(glNo: string,
    acNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransacc>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTransaccQueryKey(glNo,acNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTransacc>>> = ({ signal }) => getTransacc(glNo,acNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(glNo && acNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTransacc>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetTransaccQueryResult = NonNullable<Awaited<ReturnType<typeof getTransacc>>>
export type GetTransaccQueryError = unknown


export function useGetTransacc<TData = Awaited<ReturnType<typeof getTransacc>>, TError = unknown>(
 glNo: string,
    acNo: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransacc>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransacc>>,
          TError,
          Awaited<ReturnType<typeof getTransacc>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTransacc<TData = Awaited<ReturnType<typeof getTransacc>>, TError = unknown>(
 glNo: string,
    acNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransacc>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransacc>>,
          TError,
          Awaited<ReturnType<typeof getTransacc>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTransacc<TData = Awaited<ReturnType<typeof getTransacc>>, TError = unknown>(
 glNo: string,
    acNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransacc>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetTransacc<TData = Awaited<ReturnType<typeof getTransacc>>, TError = unknown>(
 glNo: string,
    acNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransacc>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetTransaccQueryOptions(glNo,acNo,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const deleteTransacc = (
    glNo: string,
    acNo: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/transaccs/${glNo}/${acNo}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteTransaccMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTransacc>>, TError,{glNo: string;acNo: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTransacc>>, TError,{glNo: string;acNo: string}, TContext> => {

const mutationKey = ['deleteTransacc'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTransacc>>, {glNo: string;acNo: string}> = (props) => {
          const {glNo,acNo} = props ?? {};

          return  deleteTransacc(glNo,acNo,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTransaccMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTransacc>>>
    
    export type DeleteTransaccMutationError = unknown

    export const useDeleteTransacc = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTransacc>>, TError,{glNo: string;acNo: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTransacc>>,
        TError,
        {glNo: string;acNo: string},
        TContext
      > => {

      const mutationOptions = getDeleteTransaccMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const countTransaccs = (
    params: CountTransaccsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/api/transaccs/count`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getCountTransaccsInfiniteQueryKey = (params?: CountTransaccsParams,) => {
    return [
    'infinite', `/api/transaccs/count`, ...(params ? [params]: [])
    ] as const;
    }

export const getCountTransaccsQueryKey = (params?: CountTransaccsParams,) => {
    return [
    `/api/transaccs/count`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getCountTransaccsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof countTransaccs>>>, TError = unknown>(params: CountTransaccsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof countTransaccs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCountTransaccsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof countTransaccs>>> = ({ signal }) => countTransaccs(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof countTransaccs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CountTransaccsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof countTransaccs>>>
export type CountTransaccsInfiniteQueryError = unknown


export function useCountTransaccsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof countTransaccs>>>, TError = unknown>(
 params: CountTransaccsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof countTransaccs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countTransaccs>>,
          TError,
          Awaited<ReturnType<typeof countTransaccs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCountTransaccsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof countTransaccs>>>, TError = unknown>(
 params: CountTransaccsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof countTransaccs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countTransaccs>>,
          TError,
          Awaited<ReturnType<typeof countTransaccs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCountTransaccsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof countTransaccs>>>, TError = unknown>(
 params: CountTransaccsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof countTransaccs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useCountTransaccsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof countTransaccs>>>, TError = unknown>(
 params: CountTransaccsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof countTransaccs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCountTransaccsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCountTransaccsQueryOptions = <TData = Awaited<ReturnType<typeof countTransaccs>>, TError = unknown>(params: CountTransaccsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countTransaccs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCountTransaccsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof countTransaccs>>> = ({ signal }) => countTransaccs(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof countTransaccs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CountTransaccsQueryResult = NonNullable<Awaited<ReturnType<typeof countTransaccs>>>
export type CountTransaccsQueryError = unknown


export function useCountTransaccs<TData = Awaited<ReturnType<typeof countTransaccs>>, TError = unknown>(
 params: CountTransaccsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof countTransaccs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countTransaccs>>,
          TError,
          Awaited<ReturnType<typeof countTransaccs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCountTransaccs<TData = Awaited<ReturnType<typeof countTransaccs>>, TError = unknown>(
 params: CountTransaccsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countTransaccs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countTransaccs>>,
          TError,
          Awaited<ReturnType<typeof countTransaccs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCountTransaccs<TData = Awaited<ReturnType<typeof countTransaccs>>, TError = unknown>(
 params: CountTransaccsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countTransaccs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useCountTransaccs<TData = Awaited<ReturnType<typeof countTransaccs>>, TError = unknown>(
 params: CountTransaccsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countTransaccs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCountTransaccsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCashBankTransferAccounts = (
    params: GetCashBankTransferAccountsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CoaAccountDTO[]>(
      {url: `/api/transaccs/cash-bank-transfer-accounts`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetCashBankTransferAccountsInfiniteQueryKey = (params?: GetCashBankTransferAccountsParams,) => {
    return [
    'infinite', `/api/transaccs/cash-bank-transfer-accounts`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetCashBankTransferAccountsQueryKey = (params?: GetCashBankTransferAccountsParams,) => {
    return [
    `/api/transaccs/cash-bank-transfer-accounts`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCashBankTransferAccountsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getCashBankTransferAccounts>>>, TError = unknown>(params: GetCashBankTransferAccountsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCashBankTransferAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCashBankTransferAccountsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCashBankTransferAccounts>>> = ({ signal }) => getCashBankTransferAccounts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCashBankTransferAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCashBankTransferAccountsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCashBankTransferAccounts>>>
export type GetCashBankTransferAccountsInfiniteQueryError = unknown


export function useGetCashBankTransferAccountsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCashBankTransferAccounts>>>, TError = unknown>(
 params: GetCashBankTransferAccountsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCashBankTransferAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCashBankTransferAccounts>>,
          TError,
          Awaited<ReturnType<typeof getCashBankTransferAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCashBankTransferAccountsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCashBankTransferAccounts>>>, TError = unknown>(
 params: GetCashBankTransferAccountsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCashBankTransferAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCashBankTransferAccounts>>,
          TError,
          Awaited<ReturnType<typeof getCashBankTransferAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCashBankTransferAccountsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCashBankTransferAccounts>>>, TError = unknown>(
 params: GetCashBankTransferAccountsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCashBankTransferAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCashBankTransferAccountsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCashBankTransferAccounts>>>, TError = unknown>(
 params: GetCashBankTransferAccountsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCashBankTransferAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCashBankTransferAccountsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetCashBankTransferAccountsQueryOptions = <TData = Awaited<ReturnType<typeof getCashBankTransferAccounts>>, TError = unknown>(params: GetCashBankTransferAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCashBankTransferAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCashBankTransferAccountsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCashBankTransferAccounts>>> = ({ signal }) => getCashBankTransferAccounts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCashBankTransferAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCashBankTransferAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getCashBankTransferAccounts>>>
export type GetCashBankTransferAccountsQueryError = unknown


export function useGetCashBankTransferAccounts<TData = Awaited<ReturnType<typeof getCashBankTransferAccounts>>, TError = unknown>(
 params: GetCashBankTransferAccountsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCashBankTransferAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCashBankTransferAccounts>>,
          TError,
          Awaited<ReturnType<typeof getCashBankTransferAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCashBankTransferAccounts<TData = Awaited<ReturnType<typeof getCashBankTransferAccounts>>, TError = unknown>(
 params: GetCashBankTransferAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCashBankTransferAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCashBankTransferAccounts>>,
          TError,
          Awaited<ReturnType<typeof getCashBankTransferAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCashBankTransferAccounts<TData = Awaited<ReturnType<typeof getCashBankTransferAccounts>>, TError = unknown>(
 params: GetCashBankTransferAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCashBankTransferAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCashBankTransferAccounts<TData = Awaited<ReturnType<typeof getCashBankTransferAccounts>>, TError = unknown>(
 params: GetCashBankTransferAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCashBankTransferAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCashBankTransferAccountsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




